import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col-11 col-sm-8 col-md-6 col-lg-4 mx-auto mt-5" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "ログイン", -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_7 = { class: "text-end small mt-1" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("パスワードを忘れた方")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-center my-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary col-4",
    type: "submit"
  }, "ログイン")
], -1)

import { ref, unref } from 'vue'
import { useRouter } from 'vue-router'
import { useNicotto } from '@/plugins/nicotto'
import { useValidateForm } from '@/components/ui/validator'
import { message } from '@/plugins/message'
import FormGroup from '@/components/ui/FormGroup.vue'
import InputEmail from '@/components/ui/InputEmail.vue'
import InputText from '@/components/ui/InputText.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SigninView',
  setup(__props) {

const email = ref('')
const password = ref('')
const error = ref('')
const formRef = ref<HTMLFormElement|null>(null)

const router = useRouter()
const nicotto = useNicotto()
const login = async() => {
  error.value = ''
  const form = unref(formRef) as unknown as HTMLFormElement
  if (useValidateForm(form).isValid()) {
    try {
      const user = await nicotto.auth.signIn(email.value, password.value)
      if (user.isAdmin()) {
        router.push('/users')
      } else {
        router.push('/')
      }
    } catch (err) {
      form.classList.remove('was-validated')
      form.querySelectorAll('.form-control').forEach(el => {
        el.classList.add('is-invalid')
      })
      error.value = message('signIn.incorrectIdOrPassword')
    }
  }
}
const reset = () => {
  error.value = ''
  const form = unref(formRef) as unknown as HTMLFormElement
  form?.querySelectorAll('.form-control').forEach(el => {
    el.classList.remove('is-invalid')
  })
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(login, ["prevent"]),
          ref_key: "formRef",
          ref: formRef,
          novalidate: ""
        }, [
          _createVNode(FormGroup, {
            label: "ID",
            horizontal: false,
            "label-for": "userId"
          }, {
            default: _withCtx(() => [
              _createVNode(InputEmail, {
                modelValue: email.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                label: "ID",
                autocomplete: "username",
                required: true,
                onBlur: reset,
                id: "userId"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(FormGroup, {
            label: "パスワード",
            horizontal: false,
            "label-for": "userPass"
          }, {
            default: _withCtx(() => [
              _createVNode(InputText, {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                label: "パスワード",
                type: "password",
                autocomplete: "current-password",
                required: true,
                onBlur: reset,
                id: "userPass"
              }, null, 8, ["modelValue"]),
              (error.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_router_link, { to: "/forgot" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _hoisted_9
        ], 40, _hoisted_5)
      ])
    ])
  ]))
}
}

})